import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { LoaderService } from '../../_services/loader.service';
import { LoaderState } from '../../interfaces/loader-state.interface';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {

  show: boolean = false;

  private subscription: Subscription;

  constructor(private loaderService: LoaderService) { }

  @Input() progress: number;

  ngOnInit() {
    this.subscription = this.loaderService.loaderState
      .subscribe((state: LoaderState) => {
        this.show = state.show;
      });

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
